<script>
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Customers from '@/services/Customers';
import vue2Dropzone from "vue2-dropzone";
import ExcelJS from 'exceljs';
import Swal from "sweetalert2";


export default {
  components: { vueDropzone: vue2Dropzone },
  data() {
    return {
      showModal: false,
      isUploading: false,
      uploadedFile: null,
      dropzoneOptions: {
        url: '/',
        maxFilesize: 5, // MB
        acceptedFiles: '.csv, .xlsx',
        autoProcessQueue: false,
        addRemoveLinks: true,
        dictDefaultMessage: 'Drop CSV or XLSX file here or click to upload'
      },
      error: null,
      emails: []  // Низа која ќе ги содржи сите мејлови
    };
  },
  methods: {
    callModalImportMembers() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.uploadedFile = null;
      this.error = null;
      this.emails = [];
      if (this.$refs.myDropzone) this.$refs.myDropzone.removeAllFiles();
    },
    handleFileAdded(file) {
      this.uploadedFile = file;
      this.error = null;
      this.emails = [];
    },
    async submitImport() {
      if (!this.uploadedFile) {
        this.error = 'Please select a CSV or XLSX file to upload';
        return;
      }

      this.isUploading = true;
      const group_id = this.$route.params.group_id;

      try {
        const allowedExtensions = ['.xlsx', '.csv', '.xls'];
        const fileName = this.uploadedFile.name.toLowerCase();

        if (!allowedExtensions.some(ext => fileName.endsWith(ext))) {
          this.error = 'Please use XLSX, XLS, or CSV files';
          this.isUploading = false;
          return;
        }

        // Process the file and WAIT for it to complete
        await this.processExcelFile(this.uploadedFile);

        if (this.emails.length === 0) {
          this.error = 'No valid emails found in the file';
          this.isUploading = false;
          return;
        }

        // Send the processed emails array and capture the response
        const response = await Customers.importMembers(group_id, { emails: this.emails });

        this.$emit('onRefresh');
        this.closeModal();


        // SweetAlert2 success notification with import results
        Swal.fire({
          title: 'Import Completed!',
          html: `
        <div style="text-align: left;">
          <p><strong>${response.data.members.message}</strong></p>
          <br>
          <p><strong>Imported:</strong> ${response.data.members.imported}</p>
          <p><strong>Failed:</strong> ${response.data.members.failed}</p>
          <p><i class="mdi mdi-information-outline"></i><small> No Azerion CRM accounts for these email addresses</small></p>
          <p><strong>Total Processed:</strong> ${response.data.members.total_processed}</p>
        </div>
      `,
          icon: response.data.members.failed === 0 ? 'success' : 'warning',
          confirmButtonText: 'OK',
          confirmButtonColor: response.data.members.failed === 0 ? '#3085d6' : '#f27474'
        });
      } catch (err) {
        this.error = err.response?.data?.error || 'Failed to import members';
        Swal.fire({
          title: 'Error!',
          text: this.error,
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        this.isUploading = false;
      }
    },
    async processExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // Validate file type before processing
        const supportedExtensions = ['xlsx', 'xls', 'csv'];
        if (!supportedExtensions.includes(fileExtension)) {
          this.error = `Unsupported file format. Please use: .xlsx, .xls, or .csv files.`;
          reject(new Error('Unsupported file format'));
          return;
        }

        reader.onload = async (e) => {
          const buffer = e.target.result;

          try {
            // Clear existing emails
            this.emails = [];
            this.error = '';

            if (fileExtension === 'csv') {
              await this.processCSVFile(buffer, file);
            } else if (['xlsx', 'xls'].includes(fileExtension)) {
              await this.processExcelFileInternal(buffer);
            }

            resolve(); // Resolve when processing is complete

          } catch (error) {
            this.error = 'Failed to process the file: ' + error.message;
            console.error('Processing error:', error);
            reject(error);
          }
        };

        reader.onerror = () => {
          this.error = 'Failed to read the file';
          reject(new Error('File read error'));
        };

        reader.readAsArrayBuffer(file);
      });
    },

// You'll need to add this method for Excel processing
    async processExcelFileInternal(buffer) {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(buffer);

      // Get the first worksheet
      const worksheet = workbook.getWorksheet(1);

      // Process each row
      worksheet.eachRow((row, rowNumber) => {
        // Skip header row if exists
        if (rowNumber === 1 && this.skipHeader) {
          return;
        }

        this.processEmailCell(row.getCell(1).value);
      });
    },

    async processCSVFile(buffer, file) {
      const text = new TextDecoder().decode(buffer);
      const lines = text.split(/\r\n|\n|\r/).filter(line => line.trim() !== '');

      const firstLine = lines[0];
      const detectedDelimiter = this.detectCSVDelimiter(firstLine);

      lines.forEach((line, lineNumber) => {
        if (lineNumber === 0 && this.skipHeader) {
          return;
        }

        if (!line.trim()) {
          return;
        }

        const columns = this.splitCSVLine(line, detectedDelimiter);

        columns.forEach((column, columnIndex) => {
          if (column && column.trim()) {
            this.processEmailCell(column);
          }
        });
      });
    },

    detectCSVDelimiter(line) {
      const delimiters = [';', ',', '\t', '|', ':'];
      const counts = delimiters.map(delim => ({
        delim,
        count: (line.match(new RegExp(`\\${delim}`, 'g')) || []).length
      }));

      const mostCommon = counts.reduce((max, current) =>
          current.count > max.count ? current : max, {count: -1, delim: ';'});

      return mostCommon.delim;
    },

    splitCSVLine(line, delimiter) {
      return line.split(delimiter)
          .map(cell => cell.trim())
          .filter(cell => cell !== '')
          .map(cell => {
            if (cell.startsWith('"') && cell.endsWith('"')) {
              return cell.slice(1, -1).trim();
            }
            return cell;
          });
    },

    processEmailCell(emailValue) {
      if (emailValue === null || emailValue === undefined || emailValue === '') {
        return;
      }

      const emailString = emailValue.toString().trim();

      if (!emailString) {
        return;
      }

      const potentialEmails = emailString.split(/[\s,;|]+/).filter(e => e.trim() !== '');

      potentialEmails.forEach((email) => {
        const trimmedEmail = email.trim();
        const cleanEmail = trimmedEmail.replace(/^["']|["']$/g, '');

        if (cleanEmail && this.validateEmail(cleanEmail)) {
          if (!this.emails.includes(cleanEmail)) {
            this.emails.push(cleanEmail);
          }
        }
      });
    },

    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
  }
};</script>

<template>
  <b-modal v-model="showModal" id="import_members" title="Import Members" title-class="font-18" centered>
    <div class="alert alert-info mb-3">
      <i class="mdi mdi-information-outline me-2"></i>
      <strong>Import Instructions:</strong><br>
      Please import a file (.csv or .xlsx) that only contains email addresses.<br>
      Please note that it may take a couple of minutes for the full import to complete, depending on the size of the import file.
    </div>
    
    <div class="mb-3">
      <vue-dropzone
          ref="myDropzone"
          id="import-members-dropzone"
      :options="dropzoneOptions"
      @vdropzone-file-added="handleFileAdded">
      </vue-dropzone>

      <p class="text-danger mt-2" v-if="error">{{ error }}</p>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="submitImport" :disabled="isUploading">
        <b-spinner v-show="isUploading" small></b-spinner>
        Import
      </b-button>
    </template>
  </b-modal>
</template>
